import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("馬上到 ")
const _hoisted_2 = { href: "https://www.facebook.com/groups/{{appConfig.groupId}}" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 開始選購商品吧～")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 您的取貨地點：")
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createVNode("b", null, "⚠️下單注意事項⚠️：", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 1.如有選項：下單方式A+1 B+1"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2.如要取消商品或更改商品數量，請重新留言取消或 +1（共2）"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" （請勿在自己回覆內更改，系統偵測不到） ")
], -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", { viewBox: "0 0 40 40" }, [
  /*#__PURE__*/_createVNode("g", { fill: "#FFFFFF" }, [
    /*#__PURE__*/_createVNode("path", { d: "M20,0 C31.2666,0 40,8.2528 40,19.4 C40,30.5472 31.2666,38.8 20,38.8 C17.9763,38.8 16.0348,38.5327 14.2106,38.0311 C13.856,37.9335 13.4789,37.9612 13.1424,38.1098 L9.1727,39.8621 C8.1343,40.3205 6.9621,39.5819 6.9273,38.4474 L6.8184,34.8894 C6.805,34.4513 6.6078,34.0414 6.2811,33.7492 C2.3896,30.2691 0,25.2307 0,19.4 C0,8.2528 8.7334,0 20,0 Z M7.99009,25.07344 C7.42629,25.96794 8.52579,26.97594 9.36809,26.33674 L15.67879,21.54734 C16.10569,21.22334 16.69559,21.22164 17.12429,21.54314 L21.79709,25.04774 C23.19919,26.09944 25.20039,25.73014 26.13499,24.24744 L32.00999,14.92654 C32.57369,14.03204 31.47419,13.02404 30.63189,13.66324 L24.32119,18.45264 C23.89429,18.77664 23.30439,18.77834 22.87569,18.45674 L18.20299,14.95224 C16.80079,13.90064 14.79959,14.26984 13.86509,15.75264 L7.99009,25.07344 Z" })
  ])
], -1 /* HOISTED */)

import { computed, useCssModule } from 'vue'
import { useIdentity } from '@/composables/useIdentity'
import { useBranches } from '@/composables/useBranches'
import Card from '@/components/Card.vue'


export default _defineComponent({
  expose: [],
  setup(__props) {

const appConfig = app_config
const identity = useIdentity()
const style = useCssModule()
const branches = useBranches()
const sendTo = computed(() => `http://m.me/${identity.pageId ?? app_config.pageId}?ref=${identity.id}`)
const branchName = computed(() => {
	if (!identity.defaultBranch || identity.defaultBranch === 0) {
		return '<未設定>'
	}

	const branch = branches.value.find(({ BranchID }) => BranchID === identity.defaultBranch)
	return branch.BranchName ?? '<未設定>'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, null, {
    default: _withCtx(() => [
      _createVNode("p", null, [
        _hoisted_1,
        _createVNode("a", _hoisted_2, _toDisplayString(_unref(appConfig).groupName), 1 /* TEXT */),
        _hoisted_3
      ]),
      _createVNode("p", null, [
        _hoisted_4,
        _createVNode("span", {
          class: _unref(style).branchName
        }, _toDisplayString(_unref(branchName)), 3 /* TEXT, CLASS */),
        _hoisted_5,
        _createTextVNode(" 您的聯絡方式：" + _toDisplayString(_unref(identity).phone), 1 /* TEXT */)
      ]),
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _createCommentVNode("<p>\n\t\t若有任何問題，請聯絡 {{ appConfig.pageName }}。\n\t</p>"),
      _createVNode("a", {
        href: _unref(sendTo),
        target: "_blank",
        class: _unref(style).sendToMessenger
      }, [
        _hoisted_9,
        _createCommentVNode("<span>開啟粉專 {{ appConfig.pageName }}</span>")
      ], 10 /* CLASS, PROPS */, ["href"])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})